import { AxiosError } from 'axios';
import { BrandCode } from '../../curriculum';
import { getCurriculumPricing } from '../../curriculum/api/getCurriculumPricing';
import { getTrialCode } from '../api/getTrialCode';
import { TrialCodes } from '../models/response';

export const getPreviewCurriculum = (brandCode: BrandCode) => {
  return getCurriculumPricing(brandCode)
    .then(curriculumPricingEntities => {
      if (curriculumPricingEntities.length === 0) {
        throw new Error(`Unable to find ${brandCode} curriculum pricing`);
      }
      return curriculumPricingEntities[0];
    })
    .then(curriculumPricingEntity => {
      const { curriculum } = curriculumPricingEntity;

      return curriculum
        .filter(c => !!c.license[0]?.itemNumber)
        .map(c => ({ name: c.name, itemNumber: c.license[0].itemNumber }));
    });
};

export const getTrialCurriculum = (brandCode: BrandCode) => {
  return getTrialCode(brandCode)
    .then((trial: TrialCodes) => {
      return Object.keys(trial.ageGroupToLin).map(name => ({ name, itemNumber: trial.ageGroupToLin[name] }));
    })
    .catch((error: AxiosError) => {
      if (error.status === 404) {
        return [];
      }

      throw error;
    });
};
